const alreadyRegistered = (modulesNamespace, moduleName) => {
  const modules = new Set(Object.keys(modulesNamespace)
                        .map(m => m.split('/'))
                        .reduce((p, c) => p.concat(c))
                        .filter(n => n.length > 0))
  for (let entry of modules.keys()) {
    if (entry === moduleName) return true
  }
  return false
}

export default (opts) => {
  const { modulesNamespace, moduleName, module, store, modulePath, registerOptions } = opts
  return new Promise((resolve, reject) => {
    if (alreadyRegistered(modulesNamespace, moduleName)) resolve()
    else {
      module().then(m => {
        store.registerModule(modulePath, m.default, registerOptions)
        resolve()
      })
    }
  })
}
